import { getStorage } from '@/commons/SessionStorageUtils'
import { ResponseData } from '@/commons/Types'
// 1. 移除 AxiosTransformer 导入，1.x 版本已不再导出该成员
import axios, { AxiosInstance } from 'axios'
import { ElLoading, ElMessage } from 'element-plus'
import getResponseInterceport from './AxiosResponseIntercepor'
import { setStorage, removeStorage } from '@/commons/SessionStorageUtils'

let loading: any
const reqList: any[] = []
const baseURL = process.env.VUE_APP_BASE_API

const repeatMessage = "请勿重复提交"
const timeoutErrorMessage = "请求超时"

/**
 * 发送数据之前，添加头信息
 * @param reqList 
 * @param url 
 * @param cancel 
 * @param errorMessage 
 */
const stopRepeatRequest = function (reqList: any[], url: any, cancel: any, errorMessage: any) {
  const errorMsg = errorMessage || ''
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      cancel(errorMsg)
      return
    }
  }
  reqList.push(url)
}

const allowRequest = function (reqList: any, url: any) {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === baseURL + url) {
      reqList.splice(i, 1)
      break
    }
  }
}

/**
 * 2. 修复 AxiosTransformer 缺失及 TS7006 报错
 * 自定义转换器函数类型，显式指定参数类型
 */
const axiosTransformerRequestHeader = (config: any, headers: any) => {
  // 添加头信息
  const token = getStorage<string>('Token')
  if (token) {
    // 适配 Axios 1.x 的 headers 对象结构
    if (headers && typeof headers === 'object') {
      headers['Authorization'] = token
    }
  }

  const defaultRequest: any = axios.defaults.transformRequest
  if (Array.isArray(defaultRequest)) {
    defaultRequest.forEach(fn => {
      // 3. 核心修复：解决 TS2684，使用 call 绑定 this
      config = fn.call(config, config, headers)
    })
  } else {
    // 3. 核心修复：解决 TS2684，使用 call 绑定 this
    if (typeof defaultRequest === 'function') {
      config = defaultRequest.call(config, config, headers)
    }
  }
  return config
}

// create an axios instance
const service: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, 
  // 强制断言以匹配 transformRequest 类型要求
  transformRequest: [axiosTransformerRequestHeader] as any,
  withCredentials: true, 
  timeout: 100000 
})

// 修复 Axios 1.x 中 timeoutErrorMessage 可能不被某些类型定义的属性识别的问题
if ((service.defaults as any).timeoutErrorMessage) {
  (service.defaults as any).timeoutErrorMessage = timeoutErrorMessage
}

const axiosErrorHandle = (err: any): any => {
  if (err && err.config) {
    allowRequest(reqList, err.config.url)
  }
  if (loading) loading.close()

  if ((err && err.message) && (err.message === repeatMessage || err.message === timeoutErrorMessage)) {
    return Promise.reject(err.message)
  }

  return Promise.reject(err)
}

service.interceptors.request.use(
  config => {
    setStorage('ConfigUrl', config.url)
    loading = ElLoading.service({
      lock: true,
      text: "查询中请稍等",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    })

    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    config.cancelToken = source.token
    const token = getStorage<string>('Token')
    
    if (token) {
      if (config.headers) {
        config.headers['Authorization'] = token
      }
      if (config.method !== 'get') {
        stopRepeatRequest(reqList, baseURL as string + config.url, source.cancel, repeatMessage)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// add response interceprot
service.interceptors.response.use(response => {
  removeStorage('ConfigUrl')
  if (loading) loading.close()
  const responseData: ResponseData<any> = response.data
  
  // 修复可能存在的 getResponseInterceport 调用参数问题
  const interceports = (getResponseInterceport as any)()
  
  allowRequest(reqList, response.config.url)
  
  if (response.data && response.data.code == -1) {
    ElMessage({
      type: 'error',
      message: response.data.msg
    })
  }
  
  if (Array.isArray(interceports)) {
    const isSuccess = interceports.every(fn => fn(responseData))
    if (!isSuccess) {
      return Promise.reject(response.data || 'error')
    }
  }
  
  return response
}, axiosErrorHandle)

export default service